export const NAVIGATION_TYPE_CLOSE_TAB = "NAVIGATION_TYPE_CLOSE_TAB";
export const NAVIGATION_TYPE_NAVIGATE_TO_OTHER_PAGE =
  "NAVIGATION_TYPE_NAVIGATE_TO_OTHER_PAGE";
